export enum ArtfactKind {
    MODEL = 0,
    FORM = 1,
    ANY = 2,
    STRING = 3,
    DOWNLOAD = 4,
    ERROR = 5,
    ARRAY = 6,
    REFRESH = 7,
    NORMAL = 10,
    FILE = 11,
    REDIRECT = 12,
    PROGRESS = 13,
    EMPTY = 14
}
